import Alert from "react-bootstrap/Alert";
import Container from "react-bootstrap/Container";

export default function ErrorWall({
  title = null,
  children = null,
  error = null,
}) {
  console.log(error);
  return (
    <div className="d-flex flex-column w-100 vh-100 align-items-center justify-content-center">
      <Alert variant="danger">
        <Container>
          <Alert.Heading>{title || "Ops... Erro ao carregar!"}</Alert.Heading>
          {!!error && <p>{error}</p>}
          {children !== null && children}
        </Container>
      </Alert>
    </div>
  );
}
